export default __webpack_public_path__ + "static/media/carbon_idea.acb3dd2b.svg";